import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'MASKINGS';

const fields = [
  'BTAX_BIN',
  'BTAX_BIN_REGEX',
  'RPTAX_TDN',
  'RPTAX_TDN_REGEX',
  'RPTAX_PIN',
  'RPTAX_PIN_REGEX',
  'RPTAX_PIN_2',
  'RPTAX_PIN_REGEX_2',
  'RPTAX_OR',
  'RPTAX_OR_REGEX',
  'RPTAX_OR_DISABLE_MASK',
  'BTAX_BIN_CSV',
  'BTAX_BIN_REGEX_CSV',
  'RPTAX_TDN_CSV',
  'RPTAX_TDN_REGEX_CSV',
  'RPTAX_PIN_CSV',
  'RPTAX_PIN_REGEX_CSV',
  'RPTAX_PIN_2_CSV',
  'RPTAX_PIN_REGEX_2_CSV',
  'RPTAX_TDN_TAX_PAYMENT',
  'RPTAX_TDN_TAX_PAYMENT_REGEX',
  'LGU_PIN',
  'RPTAX_PIN_19',
  'RPTAX_PIN_REGEX_19',
  'RPTAX_PIN_23',
  'RPTAX_PIN_REGEX_23',

  // Go!BPLS
  'BPLS_E2E_SEC_NO',
  'BPLS_E2E_SEC_NO_REGEX',
  'DEFAULT_BPLS_E2E_SEC_NO',
  'BPLS_E2E_DTI_NO',
  'BPLS_E2E_DTI_NO_REGEX',
  'DEFAULT_BPLS_E2E_DTI_NO',
  'BPLS_E2E_CDA_NO',
  'BPLS_E2E_CDA_NO_REGEX',
  'DEFAULT_BPLS_E2E_CDA_NO',

  'BPLS_E2E_TIN_NO',
  'BPLS_E2E_TIN_NO_PLACEHOLDER',
  'BPLS_E2E_TIN_NO_REGEX',

  'BPLS_E2E_PIN',
  'BPLS_E2E_PIN_PLACEHOLDER',
  'BPLS_E2E_PIN_REGEX',

  'BPLS_E2E_PIN_19_DIGIT',
  'BPLS_E2E_PIN_19_DIGIT_PLACEHOLDER',
  'BPLS_E2E_PIN_19_DIGIT_REGEX',
  'BPLS_E2E_TDN',
  'BPLS_E2E_TDN_PLACEHOLDER',
  'BPLS_E2E_TDN_REGEX',

  'OVR_NUMBER',
  'OVR_NUMBER_REGEX',
  'OVR_DRIVER_LICENSE_NUMBER',
  'OVR_DRIVER_LICENSE_NUMBER_REGEX',

  'DEFAULT_CEDULA_SERIAL_NUMBER',
  'CEDULA_SERIAL_NUMBER',
  'CEDULA_SERIAL_NUMBER_REGEX',
  'CEDULA_INDIVIDUAL_SERIAL_NO_LABEL',
  'CEDULA_CORPORATE_SERIAL_NO_LABEL',

  'EBPLS_TIN_NO',
  'EBPLS_TIN_NO_PLACEHOLDER',
  'EBPLS_TIN_NO_REGEX',
  'EBPLS_PAG_IBIG_NO',
  'EBPLS_PAG_IBIG_NO_PLACEHOLDER',
  'EBPLS_PAG_IBIG_NO_REGEX',
  'EBPLS_PHILHEALTH_NO',
  'EBPLS_PHILHEALTH_NO_PLACEHOLDER',
  'EBPLS_PHILHEALTH_NO_REGEX',
  'EBPLS_GSIS_NO',
  'EBPLS_GSIS_NO_PLACEHOLDER',
  'EBPLS_GSIS_NO_REGEX',
  'EBPLS_BUSINESS_ID_NO',
  'EBPLS_BUSINESS_ID_NO_PLACEHOLDER',
  'EBPLS_PIN',
  'EBPLS_PIN_PLACEHOLDER',
  'EBPLS_PIN_REGEX',
  'EBPLS_TDN',
  'EBPLS_TDN_PLACEHOLDER',
  'EBPLS_TDN_REGEX',
];

function Maskings({
  getList,
  createInput,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  createCheckbox,
}) {
  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        type: CMS_TYPE,
        body: JSON.stringify(_.pick(formData, fields)),
      });
    }

    return create({
      type: CMS_TYPE,
      body: JSON.stringify(_.pick(formData, fields)),
    });
  };

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        {createHidden({ key: 'id' }, { placeholder: '' })}

        <div className="row">
          <div className="col-12 form-group group-cms-color">
            <b>API</b>
          </div>

          <div className="col-12 form-group group-cms-color">
            <i>Go! BPLS</i>
            <hr />
          </div>

          <div className="col-12 form-group group-cms-color d-flex flex-row">
            {createCheckbox(
              { key: 'DEFAULT_BPLS_E2E_SEC_NO', label: 'Set Default SEC_NO:' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {_.get(formData, 'DEFAULT_BPLS_E2E_SEC_NO') && (
              <i className="text-muted">
                {' '}
                (min of 5chars, max of 20 chars, Alphanumeric)
              </i>
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_SEC_NO', label: 'BPLS_E2E_SEC_NO' },
              {
                required: !_.get(formData, 'DEFAULT_BPLS_E2E_SEC_NO'),
                type: 'text',
                disabled: _.get(formData, 'DEFAULT_BPLS_E2E_SEC_NO'),
              }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_SEC_NO_REGEX', label: 'BPLS_E2E_SEC_NO_REGEX' },
              {
                required: !_.get(formData, 'DEFAULT_BPLS_E2E_SEC_NO'),
                type: 'text',
                disabled: _.get(formData, 'DEFAULT_BPLS_E2E_SEC_NO'),
              }
            )}
          </div>

          <div className="col-12 form-group group-cms-color d-flex flex-row">
            {createCheckbox(
              { key: 'DEFAULT_BPLS_E2E_DTI_NO', label: 'Set Default DTI_NO:' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {_.get(formData, 'DEFAULT_BPLS_E2E_DTI_NO') && (
              <i className="text-muted">
                {' '}
                (min of 5chars, max of 20 chars, Alphanumeric)
              </i>
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_DTI_NO', label: 'BPLS_E2E_DTI_NO' },
              {
                required: !_.get(formData, 'DEFAULT_BPLS_E2E_DTI_NO'),
                type: 'text',
                disabled: _.get(formData, 'DEFAULT_BPLS_E2E_DTI_NO'),
              }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_DTI_NO_REGEX', label: 'BPLS_E2E_DTI_NO_REGEX' },
              {
                required: !_.get(formData, 'DEFAULT_BPLS_E2E_DTI_NO'),
                type: 'text',
                disabled: _.get(formData, 'DEFAULT_BPLS_E2E_DTI_NO'),
              }
            )}
          </div>

          <div className="col-12 form-group group-cms-color d-flex flex-row">
            {createCheckbox(
              { key: 'DEFAULT_BPLS_E2E_CDA_NO', label: 'Set Default CDA_NO:' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {_.get(formData, 'DEFAULT_BPLS_E2E_CDA_NO') && (
              <i className="text-muted">
                {' '}
                (min of 5chars, max of 20 chars, Alphanumeric)
              </i>
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_CDA_NO', label: 'BPLS_E2E_CDA_NO' },
              {
                required: !_.get(formData, 'DEFAULT_BPLS_E2E_CDA_NO'),
                type: 'text',
                disabled: _.get(formData, 'DEFAULT_BPLS_E2E_CDA_NO'),
              }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_CDA_NO_REGEX', label: 'BPLS_E2E_CDA_NO_REGEX' },
              {
                required: !_.get(formData, 'DEFAULT_BPLS_E2E_CDA_NO'),
                type: 'text',
                disabled: _.get(formData, 'DEFAULT_BPLS_E2E_CDA_NO'),
              }
            )}
          </div>

          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_TIN_NO', label: 'BPLS_E2E_TIN_NO' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'BPLS_E2E_TIN_NO_PLACEHOLDER',
                label: 'BPLS_E2E_TIN_NO_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_TIN_NO_REGEX', label: 'BPLS_E2E_TIN_NO_REGEX' },
              { required: false, type: 'text' }
            )}
          </div>

          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_PIN', label: 'BPLS_E2E_PIN' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'BPLS_E2E_PIN_PLACEHOLDER',
                label: 'BPLS_E2E_PIN_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_PIN_REGEX', label: 'BPLS_E2E_PIN_REGEX' },
              { required: false, type: 'text' }
            )}
          </div>

          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_PIN_19_DIGIT', label: 'BPLS_E2E_PIN_19_DIGIT' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'BPLS_E2E_PIN_19_DIGIT_PLACEHOLDER',
                label: 'BPLS_E2E_PIN_19_DIGIT_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'BPLS_E2E_PIN_19_DIGIT_REGEX',
                label: 'BPLS_E2E_PIN_19_DIGIT_REGEX',
              },
              { required: false, type: 'text' }
            )}
          </div>

          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_TDN', label: 'BPLS_E2E_TDN' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'BPLS_E2E_TDN_PLACEHOLDER',
                label: 'BPLS_E2E_TDN_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'BPLS_E2E_TDN_REGEX', label: 'BPLS_E2E_TDN_REGEX' },
              { required: false, type: 'text' }
            )}
          </div>

          <div className="col-12 form-group group-cms-color">
            <i>BTAX</i>
            <hr />
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BTAX_BIN', label: 'BTAX_BIN' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BTAX_BIN_REGEX', label: 'BTAX_BIN_REGEX' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-12 form-group group-cms-color">
            <i>RPTAX</i>
            <hr />
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_TDN', label: 'RPTAX_TDN' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_TDN_REGEX', label: 'RPTAX_TDN_REGEX' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN', label: 'RPTAX_PIN' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_REGEX', label: 'RPTAX_PIN_REGEX' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_2', label: 'RPTAX_PIN_2' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_REGEX_2', label: 'RPTAX_PIN_REGEX_2' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_19', label: 'RPTAX_PIN_19' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_REGEX_19', label: 'RPTAX_PIN_REGEX_19' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_23', label: 'RPTAX_PIN_23' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_REGEX_23', label: 'RPTAX_PIN_REGEX_23' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        {/* Disable masking in OR */}
        <div className="row">
          <div className="col-12 form-group group-cms-color d-flex flex-row">
            {createCheckbox(
              { key: 'RPTAX_OR_DISABLE_MASK', label: 'RPTAX_OR_DISABLE_MASK' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        {/* OR */}
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_OR', label: 'RPTAX_OR' },
              {
                required: true,
                type: 'text',
                disabled: _.get(formData, 'RPTAX_OR_DISABLE_MASK'),
              }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_OR_REGEX', label: 'RPTAX_OR_REGEX' },
              {
                required: true,
                type: 'text',
                disabled: _.get(formData, 'RPTAX_OR_DISABLE_MASK'),
              }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_TDN_TAX_PAYMENT', label: 'RPTAX_TDN_TAX_PAYMENT' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              {
                key: 'RPTAX_TDN_TAX_PAYMENT_REGEX',
                label: 'RPTAX_TDN_TAX_PAYMENT_REGEX',
              },
              { required: true, type: 'text' }
            )}
          </div>

          <div className="col-12 form-group group-cms-color">
            <i>OTHERS</i>
            <hr />
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'LGU_PIN', label: 'LGU_PIN' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group group-cms-color">
            <b>CSV</b>
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BTAX_BIN_CSV', label: 'BTAX_BIN_CSV' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'BTAX_BIN_REGEX_CSV', label: 'BTAX_BIN_REGEX_CSV' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_TDN_CSV', label: 'RPTAX_TDN_CSV' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_TDN_REGEX_CSV', label: 'RPTAX_TDN_REGEX_CSV' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_CSV', label: 'RPTAX_PIN_CSV' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_REGEX_CSV', label: 'RPTAX_PIN_REGEX_CSV' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_2_CSV', label: 'RPTAX_PIN_2_CSV' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'RPTAX_PIN_REGEX_2_CSV', label: 'RPTAX_PIN_REGEX_2_CSV' },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group group-cms-color">
            <b>OVR</b>
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'OVR_NUMBER', label: 'OVR_NUMBER' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'OVR_NUMBER_REGEX', label: 'OVR_NUMBER_REGEX' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              {
                key: 'OVR_DRIVER_LICENSE_NUMBER',
                label: 'OVR_DRIVER_LICENSE_NUMBER',
              },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              {
                key: 'OVR_DRIVER_LICENSE_NUMBER_REGEX',
                label: 'OVR_DRIVER_LICENSE_NUMBER_REGEX',
              },
              { required: true, type: 'text' }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group group-cms-color">
            <b>CEDULA (CORPORATE & INDIVIDUAL)</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex flex-row">
            {createCheckbox(
              {
                key: 'DEFAULT_CEDULA_SERIAL_NUMBER',
                label: 'Set Default Serial Number:',
              },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {_.get(formData, 'DEFAULT_CEDULA_SERIAL_NUMBER') && (
              <i className="text-muted"> (9 digits)</i>
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'CEDULA_SERIAL_NUMBER', label: 'CEDULA_SERIAL_NUMBER' },
              {
                required: !_.get(formData, 'DEFAULT_CEDULA_SERIAL_NUMBER'),
                type: 'text',
                disabled: _.get(formData, 'DEFAULT_CEDULA_SERIAL_NUMBER'),
              }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              {
                key: 'CEDULA_SERIAL_NUMBER_REGEX',
                label: 'CEDULA_SERIAL_NUMBER_REGEX',
              },
              {
                required: !_.get(formData, 'DEFAULT_CEDULA_SERIAL_NUMBER'),
                type: 'text',
                disabled: _.get(formData, 'DEFAULT_CEDULA_SERIAL_NUMBER'),
              }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              {
                key: 'CEDULA_INDIVIDUAL_SERIAL_NO_LABEL',
                label: 'CEDULA_INDIVIDUAL_SERIAL_NO_LABEL',
              },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              {
                key: 'CEDULA_CORPORATE_SERIAL_NO_LABEL',
                label: 'CEDULA_CORPORATE_SERIAL_NO_LABEL',
              },
              { type: 'text' }
            )}
          </div>
        </div>
        {/* EBPLS */}
        <div className="row">
          <div className="col-12 form-group group-cms-color">
            <i>EBPLS</i>
            <hr />
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_TIN_NO', label: 'EBPLS_TIN_NO' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_TIN_NO_PLACEHOLDER',
                label: 'EBPLS_TIN_NO_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_TIN_NO_REGEX', label: 'EBPLS_TIN_NO_REGEX' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_PAG_IBIG_NO', label: 'EBPLS_PAG_IBIG_NO' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_PAG_IBIG_NO_PLACEHOLDER',
                label: 'EBPLS_PAG_IBIG_NO_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_PAG_IBIG_NO_REGEX',
                label: 'EBPLS_PAG_IBIG_NO_REGEX',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_PHILHEALTH_NO', label: 'EBPLS_PHILHEALTH_NO' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_PHILHEALTH_NO_PLACEHOLDER',
                label: 'EBPLS_PHILHEALTH_NO_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_PHILHEALTH_NO_REGEX',
                label: 'EBPLS_PHILHEALTH_NO_REGEX',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_GSIS_NO', label: 'EBPLS_GSIS_NO' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_GSIS_NO_PLACEHOLDER',
                label: 'EBPLS_GSIS_NO_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_GSIS_NO_REGEX',
                label: 'EBPLS_GSIS_NO_REGEX',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_PIN', label: 'EBPLS_PIN' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_PIN_PLACEHOLDER',
                label: 'EBPLS_PIN_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_PIN_REGEX', label: 'EBPLS_PIN_REGEX' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_TDN', label: 'EBPLS_TDN' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_TDN_PLACEHOLDER',
                label: 'EBPLS_TDN_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-4 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_TDN_REGEX', label: 'EBPLS_TDN_REGEX' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              { key: 'EBPLS_BUSINESS_ID_NO', label: 'EBPLS_BUSINESS_ID_NO' },
              { required: false, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group group-cms-color">
            {createInput(
              {
                key: 'EBPLS_BUSINESS_ID_NO_PLACEHOLDER',
                label: 'EBPLS_BUSINESS_ID_NO_PLACEHOLDER',
              },
              { required: false, type: 'text' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            // disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
              Submit
            </span>
          </button>
        </div>
      </form>
    </div>
  );
}

Maskings.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Maskings);
